import { Badge } from "src/components/atoms/Badge";
import { TextCell } from "../cells";
import { Column, RowData } from "../types";
import { ALL_STAGES } from "src/constants/stages";

interface StageRowData extends RowData {
  operationsStatus: string;
  tab?: string | null;
}

export const stageColumn: Column<StageRowData> = {
  label: <TextCell emphasis="medium">Stage</TextCell>,
  width: "1fr",
  cell: (rowData) => (
    <Badge
      id={rowData.id}
      backgroundColor={
        ALL_STAGES[rowData.operationsStatus as keyof typeof ALL_STAGES].color
      }
      textColor="white"
    >
      {ALL_STAGES[rowData.operationsStatus as keyof typeof ALL_STAGES].label}
    </Badge>
  ),
};
